import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    Tooltip,
    Box,
    Divider,

} from '@mui/material';
import {
    Home as HomeIcon,
    Person as PersonIcon,
    Logout as LogoutIcon
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import PhotoFilterIcon from '@mui/icons-material/PhotoFilter';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import BallotIcon from '@mui/icons-material/Ballot';
import TerminalIcon from '@mui/icons-material/Terminal';
import PsychologyIcon from '@mui/icons-material/Psychology';
const drawerWidth = 64;

export const Sidebar = () => {
    const navigate = useNavigate();
    const { logOut } = useAuth();

    const handleLogout = async () => {
        try {
            await logOut();
            navigate('/');
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    const menuItems = [
        {
            icon: <img
                src="/icon.png"
                alt="Logo"
                style={{
                    width: '36px',  // Match other icons size
                    height: '36px',
                    objectFit: 'contain'
                }}
            />,
            path: '/dashboard',
            label: 'Home'
        },
        { icon: <HomeIcon />, path: '/dashboard', label: 'Home' },
        { icon: <AddCircleIcon />, path: '/new-application', label: 'New Application' },
        { icon: <TerminalIcon />, path: '/code-editor', label: 'Code Editor' },
        { icon: <PsychologyIcon />, path: '/mock-interview', label: 'Mock Interview' },
        { icon: <WorkHistoryIcon />, path: '/faang-watch', label: 'FAANG Watch' },
        { icon: <PhotoFilterIcon />, path: '/resume-builder', label: 'Resume Builder' },
        { icon: <TravelExploreIcon />, path: '/h1b-data', label: 'H1B Data' },
        { icon: <BallotIcon />, path: '/companies', label: 'Company-wise Coding Problems' },

        { icon: <ManageAccountsIcon />, path: '/settings', label: 'Profile' },

    ];

    return (
        <Drawer
            variant="permanent"
            anchor="left"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                },
            }}
        >
            <List>
                {menuItems.map((item) => (
                    <Tooltip key={item.path} title={item.label} placement="right">
                        <ListItem
                            button
                            onClick={() => navigate(item.path)}
                            sx={{ justifyContent: 'center', py: 2 }}
                        >
                            <ListItemIcon sx={{ minWidth: 'auto' }}>
                                {item.icon}
                            </ListItemIcon>
                        </ListItem>
                    </Tooltip>
                ))}
            </List>
            <List>
                <Divider />
                <Tooltip title="Logout" placement="right">
                    <ListItem
                        button
                        onClick={handleLogout}
                        sx={{ justifyContent: 'center', py: 2 }}
                    >
                        <ListItemIcon sx={{ minWidth: 'auto' }}>
                            <LogoutIcon />
                        </ListItemIcon>
                    </ListItem>
                </Tooltip>
            </List>
        </Drawer>
    );
};

export default Sidebar;